export const fr = {
    'launcher.open': 'Ouvrir la discussion',
    'launcher.close': 'Fermer la discussion',
    'launcher.prompt': 'Posez-moi',
    'header.title': 'Assistant du site',
    'header.aiNotice': 'Vous discutez avec un assistant automatisé (IA).',
    'header.privacyLink': 'Politique de confidentialité',
    'header.contactLink': 'Contact',
    'header.languageSelector': 'Langue',
    'header.available': 'Répond instantanément',
    'language.el': 'Ελληνικά',
    'language.en': 'English',
    'language.fr': 'Français',
    'language.auto': 'Automatique',
    'composer.placeholder': 'Écrivez votre question…',
    'composer.send': 'Envoyer',
    'composer.sending': 'Envoi…',
    'conversation.newConversation': 'Nouvelle conversation',
    'conversation.starterQuestions': 'Questions fréquentes',
    'conversation.feedbackHelpful': 'Réponse utile',
    'conversation.feedbackNotHelpful': 'Réponse peu utile',
    'conversation.feedbackThanks': 'Merci pour votre avis.',
    'conversation.noEvidence': 'Je n’ai pas encore de réponse à partir des informations approuvées de ce site.',
    'conversation.sources': 'Sources',
    'conversation.aiAgent': 'Assistant IA',
    'status.connecting': 'Connexion…',
    'status.reconnecting': 'La connexion a été coupée. Nous attendons qu’elle revienne…',
    'status.notConnected': "L'assistant n'est pas encore connecté à la plateforme.",
    'error.offline': 'Le service est momentanément indisponible. Veuillez réessayer plus tard.',
    'error.offline.retry': 'Réessayer la connexion',
    'error.timeout': 'La réponse a pris trop de temps. Veuillez réessayer.',
    'error.quotaExceeded': 'La limite de réponses est atteinte. Contactez-nous pour obtenir de l’aide.',
    'error.rateLimited': 'Trop de demandes en peu de temps. Patientez un instant puis réessayez.',
    'error.unsupportedLanguage': 'Je peux répondre en grec, en anglais ou en français. Veuillez choisir une langue.',
    'error.generic': 'Une erreur est survenue. Veuillez réessayer.',
    'conversation.sourcesHint': 'À partir des pages approuvées de ce site.',
    'header.aiNoticeStrong': 'Vous discutez avec une IA — les réponses utilisent uniquement le contenu approuvé du site.',
    'contact.open': 'Contact',
    'contact.close': 'Fermer le formulaire',
    'contact.title': 'Formulaire de contact',
    'contact.required': 'Remplissez les champs obligatoires.',
    'contact.name': 'Nom',
    'contact.email': 'E-mail',
    'contact.phone': 'Téléphone (facultatif)',
    'contact.message': 'Message',
    'contact.quoteMessage': 'Je souhaite demander un devis.',
    'contact.notice': 'Vos coordonnées servent uniquement à vous recontacter au sujet de votre demande.',
    'contact.marketingOptIn': 'Je souhaite recevoir des actualités (facultatif)',
    'contact.submit': 'Envoyer',
    'contact.success': 'Votre demande a été enregistrée. Nous vous recontacterons rapidement.',
};
//# sourceMappingURL=fr.js.map